import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const Reservation = (props) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none">
    <g clipPath="url(#clip0_15933_955)">
      <path
        d="M4.03017 3.16281H5.20645L2.70686 13.2347H0.666748L4.03017 3.16281Z"
        fill="white"
        stroke="white"
      />
      <path
        d="M11.9701 3.16281H10.7938L13.2934 13.2347H15.3335L11.9701 3.16281Z"
        fill="white"
        stroke="white"
      />
      <rect
        x="7.62323"
        y="3.33758"
        width="0.790311"
        height="0.422725"
        fill="white"
        stroke="white"
        strokeWidth="0.422725"
      />
      <rect
        x="7.62326"
        y="5.21222"
        width="0.753553"
        height="0.56976"
        fill="white"
        stroke="white"
        strokeWidth="0.56976"
      />
      <path
        d="M8.29419 7.85352L8.32251 8.4707H7.71509L7.74341 7.85352H8.29419Z"
        fill="white"
        stroke="white"
      />
      <path
        d="M8.42993 11.3088L8.50317 12.7346H7.49731L7.57056 11.3088H8.42993Z"
        fill="white"
        stroke="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15933_955">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default Reservation;
